import ajax from '@/utils/ajax'

export default {
  getAIindclass(data){
    return ajax({
      url: '/ragapp/indclass',
      method: 'POST',
      data,
    })
  },
  recommendCountryByHs(data){
    return ajax({
      url: '/gt6/ai/recommendCountryByHs',
      method: 'POST',
      data,
    })
  },
  // 获取会话ID的对话详情
  getGptSessionMsg(params){
    return ajax({
      url: '/gt6/aiReport/getGptSessionMsg',
      method: 'GET',
      params,
    })
  },
  // 获取会话List
  getGptSession(){
    return ajax({
      url: '/gt6/aiReport/getGptSession',
      method: 'GET',
    })
  },
  // 进行消息评价
  setMessageScore(params){
    return ajax({
      url: '/gt6/aiReport/setMessageScore',
      method: 'GET',
      params,
    })
  },
  // 修改会话
  updateSession(data){
    return ajax({
      url: '/gt6/aiReport/updateSession',
      method: 'POST',
      data,
    })
  },
  // 获取查询条件
  getGptSessionMsgRequestData(params){
    return ajax({
      url: '/gt6/aiReport/getGptSessionMsgRequestData',
      method: 'GET',
      params,
    })
  },
  // 获取报告的国家和行业
  getReportType(params){
    return ajax({
      url: '/chat/v1/getReportType',
      method: 'GET',
      params,
    })
  },
  // 留痕接口
  saveGptLog(data){
    return ajax({
      url: '/gt6/aiReport/saveGptLog',
      method: 'POST',
      data,
    })
  },
}